import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1a4dc3ce&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1a4dc3ce&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=1a4dc3ce&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4dc3ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a4dc3ce')) {
      api.createRecord('1a4dc3ce', component.options)
    } else {
      api.reload('1a4dc3ce', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1a4dc3ce&scoped=true", function () {
      api.rerender('1a4dc3ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/invoice/index.vue"
export default component.exports